import PreviewSection from '../../PreviewSection'
import messageResource from '../../../../messageResource'

export default function OvertimeHTMLPreviewHeaderSection() {}

OvertimeHTMLPreviewHeaderSection.prototype = _.create(PreviewSection.prototype, {
    init: function(firstGroupingLevel, secondGroupingLevel, hasTimeBalance, hasOvertime, showWorkingAndLeaveTime) {
        PreviewSection.prototype.init.call(this);
        this.firstGroupingLevel = firstGroupingLevel;
        this.secondGroupingLevel = secondGroupingLevel;
        this.hasTimeBalance = hasTimeBalance;
        this.hasOvertime = hasOvertime;
        this.timeBalanceColsNum = showWorkingAndLeaveTime ? 5 : 3;
        return this;
    },

    addRows: function(tBody) {
        const row1 = this.createRow("headerRow firstHeaderRow")
        const row2 = this.createRow("headerRow secondHeaderRow")

        this.addCell(row1, ReportPreviewUtils.makeGroupingHeader([this.firstGroupingLevel, this.secondGroupingLevel]), "groupingLevelsTitle", 1, 2);

        if (this.hasTimeBalance) {
            if (this.hasOvertime)
                this.addCell(row1, "", "emptyCell", 1, 2);
            this.addCell(row1, messageResource.getMessage("report.overtime.time_balance"), "timeSpentHeaderCell", this.timeBalanceColsNum, 1);
            this.addCell(row2, this.message("report.overtime.time_balance.scheduled"), "timeSpentHeaderCell");
            if (this.timeBalanceColsNum === 5) {
                this.addCell(row2, this.message("report.overtime.time_balance.total_reported"), "timeSpentHeaderCell withoutBorderRight");
                this.addCell(row2, this.message("report.overtime.time_balance.working_time"), "timeSpentHeaderCell withoutBorderRight");
                this.addCell(row2, this.message("report.overtime.time_balance.leave_time"), "timeSpentHeaderCell");
            }else{
                this.addCell(row2, this.message("report.overtime.time_balance.reported"), "timeSpentHeaderCell");
            }
            this.addCell(row2, this.message("report.overtime.time_balance.difference"), "timeSpentHeaderCell");
        }

        if (this.hasOvertime) {
            if (this.hasTimeBalance)
                this.addCell(row1, "", "emptyCell", 1, 2);
            this.addCell(row1, messageResource.getMessage("overtime.overtime"), "overtimeHeaderCell", 2, 1);
            this.addCell(row2, this.message("report.overtime.table.reported_by_user"), "overtimeHeaderCell");
            this.addCell(row2, this.message("report.overtime.table.auto_calculated"), "overtimeHeaderCell");
        }

        this.addRow(tBody, row1);
        this.addRow(tBody, row2);
    }
});



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/overtime/OvertimeHTMLPreviewHeaderSection.js